import {ApiHelper} from "../apiHelper";
import {BaseDao} from "./BaseDao";
import {ConstantMan} from "../constantMan";
import { Observable } from 'rxjs';
import {BuyScheduleChangeRequest} from "../../models/buyScheduleChangeRequest";
import {HttpHeaders} from "@angular/common/http";

export class BuyScheduleAuditDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.BUY_SCHEDULE_AUDITS, apiHelper);
    }

    public bulkCreate(buyScheduleAudits: any[], publicId?: string): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + '/bulk';
        let headers: HttpHeaders;
        if (publicId) {
            headers = this.apiHelper.getChangeManagementPublicHeaders(publicId);
        } else {
            headers = this.apiHelper.getDefaultHeader();
        }

        return this.apiHelper.apiCall(
            url,
            'POST',
            null,
            buyScheduleAudits,
            headers
        );
    }

    public getByRequestId(changeRequestId: string, publicId?: string): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + `/by-request/${changeRequestId}`;
        let headers: HttpHeaders;
        if (publicId) {
            headers = this.apiHelper.getChangeManagementPublicHeaders(publicId);
        } else {
            headers = this.apiHelper.getDefaultHeader();
        }

        return this.apiHelper.apiCall(
          url,
          'GET',
          null,
          null,
          headers
        );
    }
}
